<template>
  <footer id="footer">
    <div class="container">
      <BRow v-if="isClient" class="justify-content-between">
        <BCol cols="12" md="4">
          <img src="@/esf_venlo_base/assets/svg/white-logo.svg" alt="logo" class="footer-logo" />
          <div class="d-flex align-items-center text-center">
            <a href="https://de.linkedin.com/company/gpw-group-gmbh" target="_blank">
              <span class="social-icon">
                <font-awesome-icon icon="fa-brands fa-linkedin" style="color: #ffffff" />
              </span>
              {{ $t("follow_us_on_linkedin") }}
            </a>
          </div>
        </BCol>
        <BCol cols="12" md="3" class="quick-links mt-3 mt-md-0">
          <div v-html="footerQuickLinks.content"></div>
        </BCol>
        <BCol cols="12" md="3" class="contact-info">
          <div v-html="footerContact.content"></div>
        </BCol>
        <BCol cols="12" md="3" v-if="isLoggedIn">
          <BButton
            class="subscribe-btn"
            @click="subscribe(currentUser.email)"
            v-if="!currentUser.is_subscribed || !isLoggedIn"
          >
            <img v-bind:src="EmailIcon" alt="email icon" class="email-icon" />
            {{ $t("sign_up_for_the_latest_products") }}
          </BButton>
          <!-- <BButton class="subscribe-btn" @click="
            unsubscribeFromNewsletter(currentUser.email, currentUser.type_of_business, store)
            " v-else>
            <img v-bind:src="EmailIcon" alt="email icon" class="email-icon" />
            {{ $t("unsubscribe_from_the_latest_products") }}
          </BButton> -->
        </BCol>
      </BRow>
    </div>
    <hr />
    <div class="container">
      <FooterCopyRight />
    </div>
  </footer>
</template>

<script setup>
import { computed, onMounted, ref, watch, nextTick } from "vue";
import FooterCopyRight from "@/esf_venlo_base/core/components/FooterCopyRight";
import { useStore } from "vuex";
import { useNewsletter } from "@storefront/core/composable/email";
// import { unsubscribeFromNewsletter } from "@/esf_venlo_base/store/modules/customer";
import { useRouter } from "vue-router";

import EmailIcon from "@/esf_venlo_base/assets/svg/email.svg";

const { subscribe } = useNewsletter();

const isClient = ref(true);
const store = useStore();
const router = useRouter();

const isLoggedIn = computed(() => store.getters["user/getIsLoggedIn"]);
const currentUser = computed(() => store.getters["user/getCurrentUser"]);
const footerQuickLinks = computed(() =>
  store.getters[`cmsBlock/getCmsBlockByIdentifier`]("footer_quick_links")
);

const footerContact = computed(() =>
  store.getters[`cmsBlock/getCmsBlockByIdentifier`]("footer_contact")
);
const makeSpaLinks = () => {
  document.querySelectorAll(".quick-links a[href^='/']").forEach((a) => {
    a.onclick = (e) => {
      e.preventDefault();
      router.push(a.getAttribute("href"));
    };
  });
};

onMounted(async () => {
  await store.dispatch("cmsBlock/single", "footer_quick_links");
  await store.dispatch("cmsBlock/single", "footer_contact");

  nextTick(makeSpaLinks);
});
watch(footerQuickLinks, () => nextTick(makeSpaLinks));
</script>
